module.exports = __webpack_public_path__ + "static/img/about.23095fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/about.png
// module id = cheP
// module chunks = 3